export enum ColorVariantsDisplayShape {
  circle = 'circle',
  square = 'square',
}
